import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

const DEFAULTS = {
  footer_description: "Des objets personnalisés, fabriqués à la main, pour accompagner avec douceur les personnes touchées par Alzheimer, l'autisme et les maladies dégénératives.",
  footer_contact_text: "Une question, un projet ?\nÉcrivez-nous, nous répondons avec attention.",
  footer_baseline: "Atelier Sérénité — Fabriqué avec soin en France.",
};

export const Footer = () => {
  const [c, setC] = useState(DEFAULTS);
  useEffect(() => { api.get("/content").then((r) => setC({ ...DEFAULTS, ...r.data })).catch(() => {}); }, []);

  return (
    <footer data-testid="footer" className="bg-foreground text-background mt-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid md:grid-cols-3 gap-12">
        <div>
          <h3 className="font-serif-display text-3xl text-background">Passerelle</h3>
          <p className="mt-4 text-background/60 text-sm leading-relaxed max-w-xs">
            {c.footer_description}
          </p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-background/40 mb-5">Naviguer</p>
          <ul className="space-y-3 text-sm text-background/70">
            <li><Link to="/boutique" className="hover:text-primary transition-colors">Boutique</Link></li>
            <li><Link to="/realisations" className="hover:text-primary transition-colors">Réalisations</Link></li>
            <li><Link to="/pathologies" className="hover:text-primary transition-colors">Pathologies & Soins</Link></li>
            <li><Link to="/professionnels" className="hover:text-primary transition-colors">Professionnels</Link></li>
            <li><Link to="/contact" className="hover:text-primary transition-colors">Demande sur mesure</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-background/40 mb-5">Contact</p>
          <p className="text-sm text-background/70 leading-relaxed">
            {c.footer_contact_text.split("\n").map((line, i) => (
              <React.Fragment key={i}>{i > 0 && <br />}{line}</React.Fragment>
            ))}
          </p>
          <Link to="/contact" className="inline-block mt-5 rounded-full border border-background/30 px-6 py-3 text-sm hover:bg-background hover:text-foreground transition-colors">
            Nous écrire
          </Link>
        </div>
      </div>
      <div className="border-t border-background/10 py-6 text-center text-xs text-background/40">
        © {new Date().getFullYear()} {c.footer_baseline}
        <Link to="/admin/login" className="ml-3 hover:text-background/70" data-testid="footer-admin-link">Espace pro</Link>
      </div>
    </footer>
  );
};
